import Vue from 'vue';
import { Colors } from '../types/pageContract';
import { systimeThemeToVuetify } from '@/util/themes/themeHelpers';
import { $vuetify } from '@/util/themes/themeInitializer';

interface IThemeStore {
  currentTheme: Colors | null;
  appIsScrolled: boolean;
  isBright: boolean;
}

const state: IThemeStore = Vue.observable({
  currentTheme: null,
  appIsScrolled: false,
  isBright: false
});

class ThemeStore {
  public get appIsScrolled(): boolean {
    return state.appIsScrolled;
  }

  public get isBright(): boolean {
    return state.isBright;
  }

  public handleThemeColors(themeColors: Colors, isBright: boolean): void {
    const theme = systimeThemeToVuetify(themeColors);
    state.isBright = isBright;

    Object.keys(theme).forEach((i) => {
      // @ts-ignore
      $vuetify.theme.themes.light[i] = theme[i];
    });

    state.currentTheme = themeColors;
  }

  public updateScrolledState(scrollState: boolean): void {
    state.appIsScrolled = scrollState;
  }
}

export default new ThemeStore();
